import React from 'react';
import { motion } from 'framer-motion';
import Scene3D from './Scene3D';

function Hero() {
  return (
    <section id="hero" className="snap-section relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* 3D Background */}
      <Scene3D />

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto">
        {/* Label */}
        <motion.p
          className="section-label"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          Real-Time Meeting Transcription
        </motion.p>

        {/* Main headline */}
        <motion.h1
          className="font-display text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.1] mb-6"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <span className="block">FOCUS ON TALKING.</span>
          <span className="block text-gray-400">WE HANDLE THE REST.</span>
        </motion.h1>
        <motion.div
          className="mb-8"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.6 }}
        >
          <span className="font-display text-5xl md:text-6xl lg:text-7xl font-bold gradient-text">NALIVOX</span>
        </motion.div>

        {/* Subtitle */}
        <motion.p
          className="text-gray-400 text-lg md:text-xl max-w-2xl mx-auto mb-10 leading-relaxed"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.6 }}
        >
          Real-time AI transcription for interviews and meetings. Get intelligent suggestions,
          instant summaries, and never miss a detail again.
        </motion.p>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.8 }}
        >
          <a href="/app" className="btn-primary inline-block">
            START FREE — NO CREDIT CARD
          </a>
        </motion.div>
      </div>

      {/* Bottom indicator */}
      <motion.div
        className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 1.2 }}
      >
        <p className="text-xs uppercase tracking-[0.3em] text-gray-500">
          Scroll to Explore
        </p>
        <motion.div
          className="w-6 h-10 rounded-full border-2 border-white/20 flex items-start justify-center p-2"
          animate={{ y: [0, 5, 0] }}
          transition={{ duration: 1.5, repeat: 10 }}
        >
          <motion.div
            className="w-1 h-2 bg-white/60 rounded-full"
            animate={{ y: [0, 8, 0] }}
            transition={{ duration: 1.5, repeat: 10 }}
          />
        </motion.div>
      </motion.div>
    </section>
  );
}

export default Hero;
